export var global="undefined"!=typeof window?window:{};